import updateURLParameter from '../helpers/updateURLParameter';
import Player from 'audio-player';

const className = "sound__item";
const selectedPrefix = "--selected";
const activePrefix = "--active";
const activeClassName = className+activePrefix;

const buttonClasses = {
	base: "sound__button",
	play: "--play",
	pause: "--pause"
}

const audioInit = ($) => {
	$(".sounds ."+className).each(function(index){
		$(this).on("click", function(){
			$("."+className).removeClass(activeClassName);
			if(!this.classList.contains(className+"--sidebar")){
				setActiveAudio(this, $);
			}
		});
	});
	$("."+buttonClasses.base).each(function(index){
		$(this).on("click", function(){
			playPauseSong(this, $);
		});

	})
}


const setActiveAudio = (audioElement, $) => {
	const audio = $(audioElement);
	const selectedItem = $(`.${className}${selectedPrefix}`);
	audio.addClass(activeClassName);
	selectedItem.html(audio.html());
	const button = selectedItem.find("."+buttonClasses.base);
	$(button).on('click', function(){
		playPauseSong(this, $);
	});
	window.history.replaceState('', '', updateURLParameter(window.location.href, "active", audio.attr('data-id')));
	if(selectedItem.is(":visible")){
		$('html, body').animate({
			scrollTop: selectedItem.offset().top - 50
		})
	}	
}

const playPauseSong = (button, $) => {
	const player = new Player();
	const $button = $(button);
	//const $playerBar = $($button.closest(".sound__player").find(".sound__bar"));
	//const $playerBarActive = $($button.closest(".sound__player").find(".sound__bar-active"));
	//$playerBar.fadeIn();

	if($button.hasClass(buttonClasses.base+buttonClasses.pause)){
		$button.removeClass(buttonClasses.base+buttonClasses.pause).addClass(buttonClasses.base+buttonClasses.play);
		player.pause();
	}else{
		$("."+buttonClasses.base).removeClass(buttonClasses.base+buttonClasses.pause).addClass(buttonClasses.base+buttonClasses.play);
		$button.removeClass(buttonClasses.base+buttonClasses.play).addClass(buttonClasses.base+buttonClasses.pause);
		const src = $button.attr('data-src');
		player.playPause(src);
	}
}


export default audioInit;